import { PriceRange } from "../hooks/context/useFiltersContext";
import { __ } from "../i18n/l10n";
import { splitNumber } from "./splitNumber";

export const formatRange = ({ min, max }: PriceRange) => {
  if (min && max) return `${splitNumber(min)} - ${splitNumber(max)}`;
  if (min) return `${__("Over")} ${splitNumber(min)}`;
  return `${__("Under")} ${max}`;
};
